import { render } from "./DeductionsBarChart.vue?vue&type=template&id=2c22b67f&scoped=true"
import script from "./DeductionsBarChart.vue?vue&type=script&lang=js"
export * from "./DeductionsBarChart.vue?vue&type=script&lang=js"

import "./DeductionsBarChart.vue?vue&type=style&index=0&id=2c22b67f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c22b67f"]])

export default __exports__